<template>
  <div v-if="prescription && dialogVisible && prId">
    <el-dialog fullscreen :modal="false" :visible.sync="dialogVisible" :before-close="handleClose" append-to-body>
      <div class="relative">
        <div id="prescription" v-loading="loading">
          <div class="mb-3">
            <div class="text-center text-2xl font-semibold text-black">
              Chi tiết Đơn Thuốc
            </div>
          </div>
          <div class="my-3 text-base">
            <div class="row mb-2">
              <div class="col text-black">
                <span class="font-bold mr-1">Mã đơn thuốc:</span>
                <span>{{ `${prescription.prescription_code}` }}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-5 text-black">
                <div class="font-bold">Tên đơn thuốc</div>
                <div>{{ prescription.name }}</div>
              </div>
              <div class="col-md-4 text-black">
                <div class="font-bold">Ngày kê đơn</div>
                <div>{{ formatDate(prescription.date) }}</div>
              </div>
              <div class="col-md-3 text-black">
                <div class="font-bold">Bác sĩ kê đơn</div>
                <div>{{ prescription.prescribed_doctor }}</div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-5 text-black">
                <div class="font-bold">Cơ sở Y Tế</div>
                <div>{{ prescription.prescribed_clinic }}</div>
              </div>
              <div class="col-md-4 text-black">
                <div class="font-bold">Lời dặn của Bác sĩ</div>
                <div>{{ prescription.description }}</div>
              </div>
              <div class="col-md-3 text-black">
                <div class="font-bold">Ngày tạo</div>
                <div>{{ formatDate(prescription.created_at) }}</div>
              </div>
            </div>
          </div>

          <el-table class="text-black font-medium text-base" :data="prescription.person_medicines" border
                    :default-sort="{ prop: 'start_date', order: 'descending' }">
            <el-table-column width="350" class-name="text-black text-base" label="Tên thuốc">
              <template slot-scope="scope">
                <span>{{ handleGetMedicineName(scope.row) }}</span>
                <div class="text-sm truncate">
                  <span v-if="scope.row.side_effect">Tác dụng phụ: {{ scope.row.side_effect }}</span>
                </div>
                <div class="text-sm truncate">
                  <span>Hướng dẫn: {{ scope.row.doctor_note }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column class-name="text-black text-base" label="ĐVT">
              <template slot-scope="scope">
                <span>{{ handleGetAmountUnit(scope.row) }}</span>
              </template>
            </el-table-column>
            <el-table-column class-name="text-black text-base" label="Số lượng">
              <template slot-scope="scope">
                <span>{{ formatNumber(scope.row.amount) }}</span>
              </template>
            </el-table-column>
            <el-table-column class-name="text-black text-base" label="Lần / ngày">
              <template slot-scope="scope">
                <span>{{ scope.row.freq_per_day }} lần</span>
              </template>
            </el-table-column>
            <el-table-column class-name="text-black text-base" label="Lượng/lần">
              <template slot-scope="scope">
                <span>
                  {{ formatNumber(scope.row.amount_per_one) }}
                  {{ handleGetAmountUnit(scope.row) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column class-name="text-black text-base" label="Lịch trình">
              <template slot-scope="scope">
                <span>
                  {{
                    scope.row.gap_day &&
                    (scope.row.gap_day > 1
                      ? "Cách " + (Number(scope.row.gap_day) - 1)
                      : "Hàng")
                  }}
                  ngày
                </span>
              </template>
            </el-table-column>
            <!-- <el-table-column
          class-name="text-black text-base"
          label="Ngày bắt đầu"
          sortable
        >
          <template slot-scope="scope">
            <span >{{scope.row.start_date ? formatDate(scope.row.start_date) : ''}}</span>
          </template>
            </el-table-column>-->
            <!-- <el-table-column
          class-name="text-black text-base"
          label="Theo dõi"
        >
          <template slot-scope="scope">
            <div><input
                type="checkbox"
                v-model="scope.row.is_monitor"
                @click="changeDrugTracking(scope.row.id,scope.row.is_monitor, $event)"
                style="cursor: pointer;"
              ></div>
          </template>
            </el-table-column>-->
          </el-table>

          <div id="action-button" class="flex mt-3">
            <div class="ml-auto">
              <div class="flex">
                <div>
                  <button type="button" class="btn btn-light mr-1" @click="handleClose" :disabled="loading">
                    Đóng
                  </button>
                </div>
                <!--                <div>-->
                <!--                  <button v-if="hasSign" type="button" class="btn bg-pri text-white mr-1" @click="signDocument"-->
                <!--                    :disabled="loading || !!prescription.sign">-->
                <!--                    <div>{{ !!prescription.sign ? "Đã" : "" }} Ký</div>-->
                <!--                  </button>-->
                <!--                </div>-->
                <el-tooltip content="Phiếu đã xác nhận, không thể sửa" placement="top" :disabled="!prescription.sign">
                  <div>
                    <button type="button" class="btn bg-pri text-white mr-1" @click="editPrescription(prescription.id)"
                            :disabled="loading || !!prescription.sign">
                      <div>Sửa đổi</div>
                    </button>
                  </div>
                </el-tooltip>
                <!-- Open this element when the signing server has already run again -->
                <!-- <div>
                  <button
                    type="button"
                    class="btn bg-pri text-white mr-1"
                    @click="openUrl({ fileName: documentLink })"
                    :disabled="loading || !prescription.sign"
                  >
                    <div>Xem / In phiếu</div>
                  </button>
                </div> -->
                <div>
                  <button type="button" class="btn bg-pri text-white mr-1" @click="handlePrint" :disabled="loading">
                    <div>Xem / In phiếu</div>
                  </button>
                </div>
              </div>
              <div class="ml-1 text-black" v-if="prescription.sign">
                ({{ prescription.sign.user.name }} đã xác nhận -
                {{ getDateTime(prescription.sign.sign_at) }})
              </div>
            </div>
          </div>
        </div>

        <ModalAddPrescription ref="ModalAddPrescription" @refresh="handleTriggerReloadEnvelope" />
        <div v-if="patientVisit && prescription">
          <TempPrescription :save_pdf="save_pdf" :formData="formDataTemp" />
        </div>
      </div>
    </el-dialog>
    <ModalSignPDF containerIDProps="PrescriptionContainerPDF" elementIDProps="PrescriptionSignerPDF"
                  imageIDProps="PrescriptionImageID" ref="PrescriptionSignerPDF" :envelopeName="envelopeName"
                  @onSuccess="handleSignDocumentSuccess" />
    <PdfViewer ref="DetailPrescriptionPdfViewer" containerIDProps="ContainerDetailPrescriptionPDFViewerID"
               elementIDProps="DetailPrescriptionPDFViewerID" />
    <el-dialog fullscreen :visible.sync="pdfPreviewVisible" :before-close="handleClosePdfPreview">
      <div class="pdf-preview">
        <iframe
          v-if="previewUrl"
          ref="previewFrame"
          class="pdf-frame"
          :src="previewUrl"
          title="Xem trước PDF"
          @load="onPreviewLoaded"
        ></iframe>
        <div v-else class="preview-empty">
          Bấm "Xem & In Phiếu" để tạo bản xem trước
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import html2pdf from 'html2pdf.js'
import ModalAddPrescription from './ModalAdd'
import appUtils from '../../../utils/appUtils'
import TempPrescription from '../../../templates/DonThuoc/TempPrescription'
import {
  DOCUMENT_SIGN_TYPES,
  ENVELOPE_DOCUMENT_TYPE,
  ENVELOPE_NAME_TYPE,
  SIGNATORY_ROLE
} from '../../../utils/constants'
import ModalSignPDF from '../../Signature/ModalSignPDF.vue'
import SignatureRequest from '../../../api/request/SignatureRequest'
import { mixinSignPdf } from '../../../utils/mixinSignPdf'
import PdfViewer from '../../PdfViewer/PdfViewer.vue'
import { mixinHasFeatures } from '@/utils/mixinHasFeatures'
import { TEMPLATE_FORMS } from '@/constants/templateConstant'

export default {
  name: 'ModalViewPrescription',
  props: ['patientVisit'],
  components: {
    ModalAddPrescription,
    TempPrescription,
    ModalSignPDF,
    PdfViewer
  },
  mixins: [mixinSignPdf, mixinHasFeatures],
  data () {
    return {
      dialogVisible: false,
      pdfPreviewVisible: false,
      prescription: {},
      loading: false,
      prId: 0,
      save_pdf: 0,
      documentLink: null,
      onPrinting: false,
      isSigning: false,
      repeats: {},
      previewUrl: '',
      rendering: false,
      pendingPrint: false,
      templateID: TEMPLATE_FORMS.MAU_PHIEU_DON_THUOC,
      template: null,
      form: null
    }
  },
  async created () {
    try {
      const res = await this.$rf.getRequest('CommonRequest').getTemplates(this.templateID)
      if (res?.data) {
        this.template = res.data
        this.initForm()
      }
    } catch (error) {
      console.log(error)
    }
  },
  computed: {
    personInfo () {
      return this.prescription?.person_info || this.patientVisit?.person_info || {}
    },
    personMedicineInfo () {
      return this.prescription?.person_medicines || []
    },
    formDataTemp () {
      let sign = null

      sign = {
        sign_at: window.moment(),
        signer_name: this.prescription?.prescribed_doctor,
        // uuid: this.prescription?.sign?.uuid,
        isDocSign: false
      }
      return {
        person: {
          ...(this.patientVisit?.person || {}),
          code:
            this.prescription?.person_info?.pid ||
            this.patientVisit?.person?.code
        },
        prescription: this.prescription,
        consultation: this.patientVisit?.consultation,
        sign,
        icd_name: this.patientVisit?.icd_name
      }
    },
    envelopeName () {
      return this.handleGetEnvelopeName(
        ENVELOPE_NAME_TYPE.patientVisit,
        this.patientVisit
      )
    }
  },
  watch: {
    dialogVisible (stt) {
      if (!stt) {
        let query = Object.assign({}, this.$route.query)
        if (query.id) {
          delete query.id
          this.$router.push({ query }).catch(() => {
          })
        }
      } else {
        let query = Object.assign({}, this.$route.query)
        if (this.prId) {
          query.id = this.prId
          this.$router.push({ query }).catch(() => {
          })
        }
      }
    },
    patientVisit (data) {
      if (data) {
        if (this.prId) {
          const _tempData = data?.prescription?.find(
            (item) => item.id === this.prId,
          )
          if (!_tempData || typeof _tempData === 'undefined') return

          this.documentLink = _tempData.document_link
        }
      }
    }
  },
  methods: {
    initForm () {
      const form = {}
      const repeats = {}
      if (!this.template?.fields?.sections) return
      for (const section of this.template?.fields?.sections) {
        if (section?.fields) {
          for (const f of section?.fields) form[f.key] = ''
        }
        if (section?.repeat) {
          const count = Math.max(section?.repeat?.count || 1, 1)
          repeats[section?.repeat?.prefix] = Array.from({ length: count }, () =>
            this.newRepeatItem(section?.repeat)
          )
        }
      }
      this.form = form
      this.repeats = repeats
    },
    newRepeatItem (repeat) {
      const item = {}
      for (const f of repeat.itemFields) item[f.key] = ''
      return item
    },
    formatNumber (value) {
      return +value
    },
    handleClose () {
      this.isSigning = false
      this.dialogVisible = false
      this.cancel()
    },
    handleClosePdfPreview () {
      this.pdfPreviewVisible = false
      this.previewUrl = ''
    },
    async handleTriggerOpenPreview (id, triggerCreateEnvelope) {
      this.loading = true
      try {
        await this.getPrescriptionByIDData(id)
        this.handlePreviewDocument()
        this.openPreview(false)
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async handleTriggerReloadEnvelope (id, triggerCreateEnvelope) {
      this.loading = true
      try {
        await this.getPrescriptionByIDData(id)
        await this.renderAndSaveDocument()
        this.openPreview(false)
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }

      // TODO: Uncomment this code when the signing server has already run again
      // if (triggerCreateEnvelope) {
      //   this.save_pdf++
      //   this.isSigning = triggerCreateEnvelope
      //   this.loading = true
      // }
    },
    async openDialog (id, triggerCreateEnvelope, reloadDocumentLink = false) {
      this.prId = id
      this.prescription = {}
      this.dialogVisible = true
      if (reloadDocumentLink) {
        this.$nextTick(async () => {
          if (id) {
            await this.handleTriggerReloadEnvelope(id, triggerCreateEnvelope)
          }
        })
      } else {
        this.$nextTick(async () => {
          if (id) {
            await this.handleTriggerOpenPreview(id, triggerCreateEnvelope)
          }
        })
      }
    },
    cancel () {
      this.prescription = {}
      this.prId = 0
    },
    formatDate (date) {
      return date && moment(date).format('DD/MM/YYYY')
    },
    async changeDrugTracking (id, status, e) {
      try {
        if (id) {
          const r = confirm('Bạn có chắc chắn thực hiện thao tác này?')
          if (r) {
            if (appUtils.isDoctor()) {
              await this.$rf
                .getRequest('DoctorRequest')
                .postPersonMedicinesMonitor(id)
                .then((res) => {
                })
            } else if (appUtils.isAdmin()) {
              await this.$rf
                .getRequest('AdminRequest')
                .postPersonMedicinesMonitor(id)
                .then((res) => {
                })
            }
          } else {
            e.target.checked = status
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    editPrescription () {
      this.$refs.ModalAddPrescription.openDialog(
        this.prescription,
        this.patientVisit
      )
    },
    isImage (file_name) {
      return file_name.toLowerCase().match(/\.(jpeg|jpg|gif|png)$/) != null
    },
    formatDateDMY (date) {
      return moment(date).format('HH:mm DD/MM/YYYY')
    },
    getLinkDownload (link) {
      return appUtils.getDocumentURL(link)
    },
    async getPrescriptionByIDData (id) {
      try {
        this.loading = true

        if (id) {
          const res = await this.$rf
            .getRequest('DoctorRequest')
            .getPrescriptionByIDV2(id)

          if (res?.data) {
            this.prescription = this.handleMapPrescriptionData(res.data)
            this.previewUrl = this.prescription?.document_link || ''
            this.loading = false
            this.$emit('refresh')
          }

          return res.data
        }
      } catch (e) {
        console.log(e)
        this.loading = false
      }
    },
    exportPdf () {
      this.loading = true
      setTimeout(async () => {
        let options = {
          margin: [7, 11, 7, 7],
          filename: `Don_Thuoc_${this.prescription?.name}_BN_${this.person?.name}.pdf`,
          html2canvas: {
            dpi: 1000,
            scale: 6,
            image: { type: 'png', quality: 1 },
            letterRendering: true,
            allowTaint: true,
            logging: true,
            useCORS: true
          },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
        }
        try {
          await html2pdf()
            .from(this.$refs.TemplatePrescription)
            .set(options)
            .save()
        } catch (error) {
          console.log(error)
        }
        this.loading = false
      }, 50)
    },
    async handleCheckHasEnvelop () {
      const signEnvelope = await this.handleCheckSignEnvelope(
        ENVELOPE_DOCUMENT_TYPE.PRESCRIPTION,
        this.prescription?.id,
        'DetailPrescriptionPdfViewer',
        'PrescriptionSignerPDF'
      )
      this.isSigning = false

      return signEnvelope
    },
    async signDocument () {
      if (!this.prescription) return
      await this.handleCheckHasEnvelop()
    },
    async handleUpdateAvailable () {
      if (!this.prescription.pharma_inventory_id) return

      const rawMedicines = this.prescription.person_medicines?.map((item) => ({
        amount: item?.amount,
        id: item?.pharma_inventory_product_id
      }))

      const params = {
        product_invent_ids: rawMedicines
      }

      try {
        await this.$rf.getRequest('DoctorRequest').postHandleAvailable(params)
      } catch (error) {
        console.log(error)
      }
    },
    openLink (link) {
      if (!link) return
      link && window.open(link, '_blank', 'noreferrer')
    },
    async openUrl ({ fileName }) {
      window.open(fileName, '_blank')
    },
    toNumber (value) {
      const parsed = Number(String(value || 0).replace(',', '.'))
      return Number.isFinite(parsed) ? parsed : 0
    },
    roundQuantity (value) {
      return Number(Number.parseFloat(value).toFixed(2))
    },
    ceilQuantity (value) {
      return Number.isFinite(value) ? Math.ceil(Number.parseFloat(value)) : 0
    },
    calcDailyAmount (medicine) {
      if (!medicine) return 0

      if (Number(medicine.is_by_day || 1) === 1) {
        return (
          this.toNumber(medicine.freq_per_day) *
          this.toNumber(medicine.amount_per_one)
        )
      }

      const amountsBySession = [
        medicine.amountMorning,
        medicine.amountNoon,
        medicine.amountAfternoon,
        medicine.amountEvening
      ].map((item) => this.toNumber(item))

      medicine.freq_per_day = amountsBySession.reduce((total, item) => {
        return item ? total + 1 : total
      }, 0)
      medicine.amount_per_one = 1

      return amountsBySession.reduce((total, item) => total + item, 0)
    },
    calcTotalDays (medicine) {
      if (!medicine) return

      const dailyAmount = this.calcDailyAmount(medicine)
      const amount = this.toNumber(medicine.amount)
      return dailyAmount && amount
        ? this.ceilQuantity(amount / dailyAmount)
        : ''
    },
    compactRepeats () {
      let result = {}
      for (const [prefix, items] of Object.entries(this.repeats)) {
        result[prefix] = items.filter(item =>
          Object.values(item).some(value => String(value || '').trim() !== '')
        )
      }

      if (result?.med?.length === 0) {
        this.personMedicineInfo.forEach((item) => {
          // eslint-disable-next-line no-unused-expressions
          result?.med?.push({
            days: this.calcTotalDays(item)?.toString() || '',
            name: `${this.handleGetMedicineName(item)}`,
            qty: item?.amount.toString() || '',
            unit: item?.amount_unit?.toString() || '',
            usage: item?.doctor_note?.toString() || ''
          })
        })
      }
      return result
    },
    buildPayload () {
      const bodyData = {
        values: {
          ...this.form,
          address: this.personInfo?.address || '',
          advice: this.prescription?.description || '',
          date: window.moment(this.prescription?.date).get('date').toString() || '',
          diagnose: this.prescription?.diagnosis || '',
          dob: window.moment(this.personInfo?.birthday).format('DD-MM-YYYY') || '',
          doctor_name: this.prescription?.prescribed_doctor || '',
          gender: appUtils.getGender(this.personInfo?.gender) || '',
          id_number: this.personInfo?.cmnd || '',
          insurance_number: this.personInfo?.insurance_number || '',
          month: (window.moment(this.prescription?.date).get('month') + 1).toString() || '',
          patient_code: this.personInfo?.pid || '',
          patient_name: this.personInfo?.name || '',
          phone: '',
          weight: this.personInfo?.weight || '',
          year: window.moment(this.prescription?.date).get('year').toString() || ''
        },
        repeats: this.compactRepeats()
      }
      return bodyData
    },
    async renderDocument () {
      if (!this.template?.id) {
        this.$message({
          message: this.$t('Không tìm thấy template để render tài liệu'),
          type: 'error'
        })
        throw new Error('Prescription template is missing')
      }
      this.rendering = true
      try {
        const { data } = await this.$rf.getRequest('CommonRequest').renderDocument(this.template?.id, this.buildPayload())
        this.previewUrl = this.getPreviewUrl(data.preview_url)
        if (!this.previewUrl) throw new Error('Rendered prescription URL is missing')
        return data
      } catch (e) {
        const message = e.response && e.response.data && e.response.data.error
        this.$message({
          message: message || this.$t('Có lỗi xảy ra khi render tài liệu'),
          type: 'error'
        })
        throw e
      } finally {
        this.rendering = false
      }
    },
    getPreviewUrl (previewPath) {
      if (!previewPath) return ''
      if (/^https?:\/\//i.test(previewPath)) return `${previewPath}?t=${Date.now()}`
      const endpoint = String(process.env.VUE_APP_PRINT_PDF_TEMPLATE_ENDPOINT || '').replace(/\/$/, '')
      const path = String(previewPath).startsWith('/') ? previewPath : `/${previewPath}`
      return `${endpoint}${path}?t=${Date.now()}`
    },
    handlePreviewDocument () {
      this.prescription = { ...this.prescription, document_link: this.previewUrl }
      return this.previewUrl
    },
    async renderAndSaveDocument () {
      await this.renderDocument()
      await this.$rf.getRequest('DoctorRequest').updatePrescriptionV2(this.prescription.id, {
        document_link: this.previewUrl
      })
      return this.handlePreviewDocument()
    },
    onPreviewLoaded () {
      if (!this.pendingPrint || !this.$refs.previewFrame) return
      this.pendingPrint = false
      const previewOrigin = new URL(this.previewUrl, window.location.href).origin
      if (previewOrigin === window.location.origin) {
        const frameWindow = this.$refs.previewFrame.contentWindow
        frameWindow.focus()
        frameWindow.print()
        return
      }

      const printWindow = window.open(this.previewUrl, '_blank', 'noopener,noreferrer')
      if (!printWindow) {
        this.$message({
          message: this.$t('Trình duyệt đã chặn cửa sổ in. Hãy cho phép popup để in đơn thuốc.'),
          type: 'warning'
        })
      }
    },
    async handlePrint () {
      if (!this.prescription?.document_link) {
        this.$message({ message: this.$t('Chưa có bản PDF đã lưu cho đơn thuốc.'), type: 'warning' })
        return
      }
      this.openPreview(true)

      // TODO: Uncomment this code when the signing server has already run again
      // const signEnvelope = await this.handleCheckHasEnvelop()
      //
      // if (!signEnvelope?.id) {
      //   this.save_pdf++
      //   this.isSigning = true
      // }
    },
    openPreview (print = false) {
      this.previewUrl = this.prescription?.document_link || ''
      this.pendingPrint = print
      this.pdfPreviewVisible = Boolean(this.previewUrl)
    },
    handleGetMedicineName (medicine) {
      const source = medicine?.medicine || medicine || {}
      const productInfo = source?.product_info || medicine?.pharma_product || {}
      const medicineName = source?.name || productInfo?.name || medicine?.name || ''
      const activeIngredient =
        source?.active_ingredient ||
        productInfo?.active_ingredient_info?.name ||
        medicine?.active_ingredient ||
        ''
      const quality =
        source?.quality ||
        source?.concentration ||
        productInfo?.quality ||
        medicine?.quality ||
        ''

      return `${activeIngredient} ${quality} ${medicineName ? `(${medicineName})` : ''
      }`
    },
    handleGetAmountUnit (medicine) {
      return (
        medicine?.medicine?.amount_unit ||
        medicine?.medicine?.product_info?.amount_unit ||
        medicine?.medicine?.product_info?.unit_name ||
        medicine?.amount_unit ||
        medicine?.pharma_product?.amount_unit ||
        ''
      )
    },
    handleMapPrescriptionData (data) {
      const prescription = _.cloneDeep(data)
      const personMedicines =
        prescription?.person_medicine || prescription?.person_medicines || []

      return {
        ...prescription,
        person_medicines: personMedicines.map((item) => ({
          ...item,
          medicine: item?.medicine || {
            id: item?.pharma_inventory_product_id,
            product_info: item?.pharma_product || {
              name: item?.name,
              amount_unit: item?.amount_unit,
              isExternal: !item?.pharma_inventory_id,
              product_code: item?.medicine_code || ''
            }
          }
        }))
      }
    },
    getDateTime (date) {
      if (!date) return ''
      return window
        .moment(date)
        .subtract(7, 'hour')
        .format('HH:mm:ss DD/MM/YYYY')
    },
    async handleSignDocumentSuccess (database64) {
      try {
        this.loading = true
        const file = appUtils.convertBase64tToFile(
          database64,
          parseInt(Date.now() / 1000)
        )
        const url = await this.uploadFiles(file, this.prescription?.id)

        await this.$rf
          .getRequest('DoctorRequest')
          .updatePrescriptionV2(this.prescription.id, { document_link: url })

        let params = {
          id: this.prescription.id,
          type_document: DOCUMENT_SIGN_TYPES.CODE.PRESCRIPTION,
          method: 1,
          inventory_id: this.prescription.pharma_inventory_id
        }
        await this.$rf.getRequest('DoctorRequest').signPrescription(params)

        await this.handleUpdateAvailable()

        // await this.getPrescriptionByIDData(this.prescription.id).then(
        //   response => {
        //     this.save_pdf++
        //   }
        // )

        // this.$message({
        //   message: this.$t('Ký xác nhận thành công'),
        //   type: 'success'
        // })
        const prescriptionData = await this.getPrescriptionByIDData(
          this.prescription.id
        )
        this.$emit('refresh')
        window.open(prescriptionData.document_link, '_blank', 'noreferrer')
      } catch (error) {
        console.log(error)
        this.loading = false
      } finally {
        this.loading = false
      }
    },
    async handleOpenSignPDF (url) {
      const procedureResponse = await this.getSignProcedure()
      const procedureSelected = procedureResponse?.data?.[0] || {}
      const signatories = procedureSelected?.sign_nodes?.reduce((arr, node) => {
        const signs = node?.node_signatories?.map((item) => {
          let user
          if (item?.user_role === 'doctor_exam') {
            user = this.prescription?.prescribed_doctor_info?.User
          }

          return {
            ...item,
            user,
            user_id: user?.id
          }
        })

        return arr.concat(signs)
      }, [])

      const signerInfo = signatories?.find(
        (item) => item?.user_id === this.$user?.id,
      )
      if (!signerInfo) {
        this.$toast.open({
          type: 'error',
          message: 'Bạn không có quyền ký tài liệu này'
        })

        return
      }

      this.$refs.PrescriptionSignerPDF.handleOpen(
        url,
        ENVELOPE_DOCUMENT_TYPE.PRESCRIPTION,
        this.prescription.id,
        signerInfo?.user_id,
        signatories,
        null,
        procedureSelected?.id
      )
    },
    async getSignProcedure () {
      try {
        const params = {
          page_num: 1,
          page_size: 1000,
          order: 'desc',
          sort_by: 'id',
          document_type: ENVELOPE_DOCUMENT_TYPE.PRESCRIPTION,
          ws_id: this.$globalClinic?.id
        }

        const request = new SignatureRequest()

        const response = await request.getSignProcedures(params)
        return response.data
      } catch (error) {
        console.log(error)
      }
    },
    async uploadFiles (file, id) {
      const params = {
        file,
        FolderTarget: `prescription`,
        IdTarget: id
      }
      const formData = new FormData()

      for (const key in params) {
        formData.append(key, params[key])
      }

      const res = await this.$rf
        .getRequest('DoctorRequest')
        .uploadFileTenant(formData)
      return res.data.fileUrl
    },
    async handleProcessSignEnvelope (documentUrl) {
      let responseData
      const procedureSelected = await this.getSignProcedures(
        ENVELOPE_DOCUMENT_TYPE.PRESCRIPTION
      )
      const signatories = procedureSelected?.sign_nodes?.reduce((arr, node) => {
        const signs = node?.node_signatories?.map((item) => {
          let user
          if (item?.user_role === 'doctor_exam') {
            user = this.prescription?.prescribed_doctor_info?.User
          }
          // const user = this.getUserByRole(item?.user_role)

          return {
            ...item,
            user,
            user_id: user?.id,
            node_signatory_id: item?.id,
            signatory_name: user?.name,
            signatory_email: user?.email,
            signatory_role: SIGNATORY_ROLE.signer,
            signatory_order: item?.sign_order,
            role_name: item?.role_name,
            is_required: item?.is_required,
            expired_date: item?.expired_date || undefined
          }
        })

        return arr.concat(signs)
      }, [])

      const signEnvelope = await this.handleGetEnvelopeByDocumentID(
        this.prescription?.id,
        ENVELOPE_DOCUMENT_TYPE.PRESCRIPTION
      )

      if (signEnvelope?.id) {
        responseData = await this.handleUpdateSignEnvelope(
          signEnvelope.id,
          signatories,
          documentUrl,
          ENVELOPE_DOCUMENT_TYPE.PRESCRIPTION,
          this.prescription?.id,
          this.envelopeName
        )

        return responseData
      } else {
        responseData = await this.handleCreateEnvelope(
          signatories,
          documentUrl,
          procedureSelected?.id,
          ENVELOPE_DOCUMENT_TYPE.PRESCRIPTION,
          this.prescription?.id,
          this.envelopeName
        )
        return responseData
      }
    }
  }
}
</script>

<style lang="scss">
@media print {
  body {
    width: 1400px;
    zoom: 100%;
  }
}

.pdf-preview {
  height: calc(100vh - 110px);
  min-height: 720px;
  background: #d9dde3;
  border: 1px solid #c9ced6;
  border-radius: 6px;
  overflow: hidden;
}

.pdf-frame {
  width: 100%;
  height: 100%;
  border: 0;
  background: #fff;
}

.preview-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 24px;
  color: #667085;
  text-align: center;
}
</style>
